import personalizeService from '../services/rbata.personalizeService';
import 'bootstrap-select';
import logger from "../utils/rbata.logger";

const settings = {
    $body:                   undefined,
    buttonSelector:          '.js-update-settings',
    $button:                 undefined,
    countrySelector:         'select.js-settings-country',
    languageSelector:        'select.js-settings-language',
    accordionHeaderSelector: '#accordion-cs-language-settings',
    isCsModal:               false,
    showMiniCart:            false,
    settings:                {
        country:      personalizeService.getCountry().toLowerCase(),
        language:     personalizeService.getLanguage().toLowerCase(),
        languageName: personalizeService.getLanguageName(),
        countryName:  personalizeService.getCountryName(),
        currency:     personalizeService.getCurrency()
    },
    cacheSelectors() {
        this.$body     = $('body');
        this.$button   = $(this.buttonSelector);
        this.isCsModal = $('.modal-cs').length;
    },
    enableButton() {
        this.$button.prop('disabled', false);
    },
    enrichAccordionHeader() {
        const template = `<span class="cs-setting-info">(${this.settings.languageName}, ${this.settings.countryName})</span>`;
        $(this.accordionHeaderSelector).find('.cs__accordion-headline').append(template);
    },
    enrichCountrySelector() {
        $('.js-settings-country').find('.filter-option-inner-inner').each((index, element) => {
            element.innerText = `${element.innerText} / ${this.settings.currency}`
        })
    },
    bindHandler() {
        this.$body.on('changed.bs.select', this.countrySelector, (evt) => {
            this.settings.country = evt.target.value.toLowerCase();
            this.enableButton();
        });
        this.$body.on('changed.bs.select', this.languageSelector, (evt) => {
            this.settings.language = evt.target.value;
            this.enableButton();
        });
        this.$body.on('click', this.buttonSelector, () => {
            const base  = window.location.origin;
            const regex = /(\/[a-zA-Z]{2}-[a-zA-Z]{2,3}\/)(.*)/;

            const buildUrl = (...args) => {
                const oldURL      = new URL(...args);
                const queryString = oldURL.search;
                const prevPath    = oldURL.pathname;
                const matcher     = prevPath.match(regex);
                const newPath     = matcher === null ? '' : matcher[2];
                return `${base}/{1}/${newPath}${queryString}`;
            }

            const applyCountryAndLanguage = (settingsPath, stayAtCurrentPage = false) => {
                if (stayAtCurrentPage) {
                    //CS modal - we want current page
                    window.location.href = buildUrl(window.location.href).replace('{1}', settingsPath)
                } else {
                    //CS page - we want previous page
                    window.location.href =
                            buildUrl(document.referrer, base).replace('{1}', settingsPath).concat(`${this.showMiniCart ? '#showMiniCart' : ''}`);
                }
            }

            personalizeService.requestCountryChange(this.settings.language, this.settings.country).then((response) => {
                settings.isCsModal ? applyCountryAndLanguage(response.path, true) : applyCountryAndLanguage(response.path);
            }, (jqXHR) => {
                logger.error(`error in change Country and Language, code: ${jqXHR.status}`);
            })
        });
    },
    requestShowMiniCart() {
        const hash = location.hash;

        if (hash !== null && hash.includes('minicart')) {
            this.showMiniCart = true;
        }
    }
};

$(() => {
    if ($(settings.buttonSelector).length) {
        settings.cacheSelectors();
        settings.requestShowMiniCart();
        settings.bindHandler();
        settings.enrichCountrySelector();
    }
    if ($(settings.accordionHeaderSelector).length) {
        settings.enrichAccordionHeader();
    }
});

export default settings;
